import SigliveServiceV3 from 'Service/sigliveServiceV3';

const getTarget = async (queries = '') => {
  const { data } = await SigliveServiceV3({ method: 'GET', url: `/target?${queries}` });

  return data?.data;
};

export default getTarget;
